/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useState } from "react";
import { IPlanningMaintenances } from "../../../../interfaces/planningsMaintenances";
import { useParams, useLocation } from "react-router-dom";
import { useEntityNavigation } from "@/hooks/useEntityNavigation";
import { toast } from "react-toastify";
import useMounted from "../../../../hooks/mounted";
import { debounce } from "lodash";
import { createPlanningMaintenances, listPlanningsMaintenances, showPlanningMaintenances, updatePlanningMaintenances, deletePlanningMaintenances } from "@/services";
import { updateValue } from "@/utils/updateValue";
import { useEntityQueryParams } from "@/hooks/useEntityQueryParams";
import { useEntitySearch } from "@/hooks/useEntitySearch";

const DEFAULT_MAINTENANCE: IPlanningMaintenances = {
  name: '',
  id: "",
  status: "pending",
  idAssigned: "",
  startDate: null,
  endDate: null
};

export const usePlanningsMaintenances = ({ filter: filterInitial, disabledShowId, includes = [], disabledGetAll, defaultLimit }: {
  disabledGetAll?: boolean;
  disabledShowId?: boolean;
  defaultLimit?: number;
  filter?: Record<string, any>,
  includes?: string[]
}) => {
  const { idPlanningMaintenance: id } = useParams();
  const localtion = useLocation();
  const [planningsMaintenances, setPlanningsMaintenances] = useState<IPlanningMaintenances[]>([]);
  const [planningMaintenances, setPlanningMaintenances] = useState<IPlanningMaintenances>(DEFAULT_MAINTENANCE);
  const { filter, setFilter, handleFilter, sort, handleSort, page, setPage, limit, setLimit } =
    useEntityQueryParams({ filter: filterInitial, defaultLimit });
  const [totalItems, setTotalItems] = useState<number>(0);
  const [enableChangePositionMap, setEnableChangePositionMap] = useState<boolean>(false)
  const { goAdd, goEdit, goBack } = useEntityNavigation({ basePath: "/towermanagement/plannings_maintenances" });

  const [loading, setLoading] = useState<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handlePlanningMaintenances = (key: string, value: any, custom?: (v: any) => any) => {
    setPlanningMaintenances((curr: any) => {
      let newData = updateValue(curr, key, value);
      if (custom) newData = custom(newData);
      return { ...curr, ...newData };
    });
  };

  const getAll = useCallback(debounce(({
    page = 1,
    limit,
    filter,
    sort
  }: {
    page?: number;
    limit?: number;
    filter?: any
    sort?: any
  }) => {
    setLoading(true);
    listPlanningsMaintenances({ includes: [...includes], filter, page, limit, sort })
      .then(({ planningsMaintenances: listPlanningsMaintenances, limit, currentPage, totalItems }) => {
        setPlanningsMaintenances(listPlanningsMaintenances);
        
        setLimit(Number(limit));
        setTotalItems(totalItems)
      })
      .finally(() => setLoading(false));
  }, 300), []);


  const search = useEntitySearch({
    list: listPlanningsMaintenances,
    key: "planningsMaintenances",
    includes: ["idSite", ...includes],
    filter,
  });


  const get = ({ id }: { id: string | number }) => {
    setLoading(true);
    showPlanningMaintenances({ id })
      .then(({ planningMaintenances: planningsMaintenancesShow }) => {
        setPlanningMaintenances(planningsMaintenancesShow);
      })
      .finally(() => setLoading(false));
  };

  const create = () => {
    setLoading(true);
    createPlanningMaintenances({ planningMaintenances })
      .then(({ planningMaintenances: planningMaintenancesCreate }) => {
        toast.success(`Planejamento criado com sucesso!`);
        goEdit(planningMaintenancesCreate.id!);
      })
      .finally(() => setLoading(false));
  };

  const update = () => {
    setLoading(true);
    updatePlanningMaintenances({ id: planningMaintenances.id!, planningMaintenances })
      .then(({ planningMaintenances: planningMaintenancesUpdate }) => {
        toast.success(`Planejamento atualizado com sucesso!`);
        goEdit(planningMaintenancesUpdate.id!);
      })
      .finally(() => setLoading(false));
  };

  const deleteMany = async (ids: (string | number)[]) => {
    if (!confirm("Deseja realmente excluir os itens selecionados?")) return;
    setLoading(true);
    try {
      await Promise.all(ids.map((id) => deletePlanningMaintenances({ id })));
      toast.success("Planejamento(s) excluído(s) com sucesso!");
      getAll({ page, limit, filter, sort });
    } catch (error) {
      toast.error("Erro ao excluir planejamento(s).");
    } finally {
      setLoading(false);
    }
  };


  useMounted(() => {
    if (!disabledGetAll) getAll({ page, limit, filter, sort })
  }, [page, limit, filter, sort])

  useEffect(() => {
    setFilter((f) => ({ ...f, ...(filterInitial || {}) }))
  }, [filterInitial])
  useEffect(() => {
    const isPage = localtion.pathname.includes('/towermanagement/plannings_maintenances');
    if (id && isPage && !disabledShowId) {
      if (id !== "new") get({ id: id });
      return;
    }
  }, []);

  return {
    planningsMaintenances,
    planningMaintenances,
    loading,
    setPage,
    setLimit,
    page,
    limit,
    goEdit,
    goBack,
    goAdd,
    handlePlanningMaintenances,
    create,
    id,
    update,
    enableChangePositionMap,
    setEnableChangePositionMap,
    totalItems,
    search,
    handleFilter,
    handleSort,
    deleteMany
  };
};
